import React, { FC, useContext } from 'react';

import { AlertIcon, Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './ShowProductShowcase.module.scss';
export const ShowProductShowcase: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('shell_goods_display');

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        label={t('setting.shell.showcaseGoods.label')}
        description={t('settings.shell.showcaseGoods.description')}
        value={settings.shellGoodsDisplayEnabled}
        onChange={(value: string) => {
          setSetting({
            alias: ESettingsAliases.SHELL_GOODS_DISPLAY_ENABLED,
            value: value ? '1' : '0',
          });
        }}
        variant="secondary"
        emptyBg
        disabled={!isAvailable}
        rightContent={!isAvailable ? <SettingsLock /> : undefined}
        className={s.toggle}
      />
      <div className={s.helper}>
        <AlertIcon size="s" />
        {t('setting.shell.showcaseGoods.notification')}
      </div>
    </>
  );
};
